import Helmet from '@plone/volto/helpers/Helmet/Helmet';
import { useSelector } from 'react-redux';

// documentação: https://developers.google.com/search/docs/appearance/structured-data/article?hl=pt_BR#guidelines
// ferramenta de testes: https://search.google.com/test/rich-results?hl=pt-br
// ferramenta de geração de dados estruturados: https://www.google.com/webmasters/markup-helper/

const GoogleStructuredData = () => {
  const content = useSelector((state) => state.content?.data);

  if (!content || content['@type'] !== 'News Item') {
    return null;
  }

  const {
    title = null,
    image = {},
    effective = null,
    modified = null,
    creators = [],
  } = content;

  const url_imagem = image?.download || null;

  const structuredData = {
    '@context': 'https://schema.org',
    '@type': 'NewsArticle',
    ...(title && { headline: title }),
    ...(url_imagem && { image: url_imagem }),
    ...(effective && { datePublished: effective }),
    ...(modified && { dateModified: modified }),
    ...(creators.length > 0 && {
      author: creators.map((creator) => ({
        '@type': 'Person',
        name: creator,
      })),
    }),
  };
  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(structuredData)}
      </script>
    </Helmet>
  );
};

export default GoogleStructuredData;
